<!--
 * @Author: Merlin
 * @Date: 2024-10-08 20:00:51
 * @LastEditors: Merlin
 * @LastEditTime: 2025-04-28 13:01:57
 * @Description: 
-->
<template>
    <div class="flex py-6 w-full flex-col gap-3 xl:flex-row-reverse relative">
        <Board
            id="board-popup"
            :man="coefficients.man"
            v-model:round="coefficients.round"
            :bet-is-locked="coefficients.betIslocked"
            :isGameContent="true"
            :stairRows="stairRows"
        />
    </div>
</template>

<script lang="ts" setup>
import Board from '~/pages/casino/stairsGame/_components/Board.vue';
import { useStair } from '~/pages/casino/stairsGame/composable/useStair';
import type { BetHistoryType } from '~/socket/gamehistory/dto/gameHistory.dto';

const props = defineProps({
    history: {
        type: Object as PropType<BetHistoryType>,
        required: true,
    },
});
const { coefficients, handleManPosition, stairRows } = useStair(null, true);

onMounted(() => {
    coefficients.round = {
        ...coefficients.round,
        ...props.history,
        ...props.history.state,
    };
    coefficients.man.isPopup = true;
    const boardElement = document.getElementById('board-popup');
    handleManPosition(boardElement);
});
</script>